export default __webpack_public_path__ + "static/allency-banner-know-us-c5cfa27f0e8386368b5ae008661cfc6f.png";